export const ALERT_READING_VALUE = `You entered a prescription with a negative (-) sphere but indicated that you use your glasses for reading. Most people with reading prescriptions have a positive (+) sphere. Are you sure your prescription shows a negative (-) sphere?
            
For help, please contact our customer service. You may also fax your prescription to 888-250-6925
            
This lens is not available in your prescription`;

export const ALERT_SINGLEVISION_VALUE = `You entered a prescription with a positive (+) sphere but indicated that you use your glasses for distance. Most people with distance prescriptions have a negative (-) sphere. Are you sure your prescription shows a positive (+) sphere?

For help, please contact our customer service. You may also fax your prescription to 888-250-6925`;

export const ALERT_SAME_VALUE = `You entered the same values for both eyes (right and left). Most people have different prescriptions for each eye. Are you sure your prescription shows the same values for both eyes?

For help, please contact our customer service. You may also fax your prescription to 888-250-6925`;
